/**
 * @file pages/Quiz.js
 * @description Quiz biblique avec bibliothèque de questions et catégories
 */

import React, { useState, useEffect, useCallback, useRef } from 'react';

// ─── BIBLIOTHÈQUE DE QUESTIONS ────────────────────────────────────────────────
const QUESTION_LIBRARY = [

  // ══════════════════ LIVRE : ROMAINS ══════════════════
  { id: 1, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Qui a écrit l'épitre aux Romains ?",
    options: ["Pierre", "Paul", "Jean", "Jacques"], correct: 1,
    explication: "Paul de Tarse a écrit l'épitre aux Romains depuis Corinthe vers 57 ap. J.-C." },

  { id: 2, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Depuis quelle ville Paul a-t-il écrit l'épitre aux Romains ?",
    options: ["Rome", "Antioche", "Corinthe", "Ephese"], correct: 2,
    explication: "Paul a écrit l'épitre aux Romains depuis Corinthe, probablement lors de son troisieme voyage missionnaire." },

  { id: 3, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Combien de chapitres compte l'épitre aux Romains ?",
    options: ["14", "15", "16", "17"], correct: 2,
    explication: "L'épitre aux Romains comporte 16 chapitres." },

  { id: 4, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Facile',
    question: "Selon Romains 3:23, qui a péché ?",
    options: ["Les non-croyants", "Les Juifs seulement", "Tous les hommes", "Les Gentils seulement"], correct: 2,
    explication: "Romains 3:23 : 'Tous ont péché et sont privés de la gloire de Dieu.'" },

  { id: 5, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Facile',
    question: "Selon Romains 6:23, quel est le salaire du péché ?",
    options: ["La souffrance", "La mort", "L'exil", "La honte"], correct: 1,
    explication: "Romains 6:23 : 'Le salaire du péché c'est la mort, mais le don gratuit de Dieu c'est la vie éternelle.'" },

  { id: 6, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Facile',
    question: "Romains 1:17 dit que le juste vivra par ___",
    options: ["les oeuvres", "la loi", "la foi", "la grace"], correct: 2,
    explication: "Romains 1:17 : 'Le juste vivra par la foi' - citation du prophete Habacuc 2:4." },

  { id: 7, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Selon Romains 10:9, que faut-il confesser pour être sauvé ?",
    options: ["Ses péchés", "Que Jésus est Seigneur", "La loi de Moise", "Sa foi en l'Église"], correct: 1,
    explication: "Romains 10:9 : 'Si tu confesses de ta bouche le Seigneur Jésus et si tu crois en ton coeur que Dieu l'a ressuscité des morts, tu seras sauvé.'" },

  { id: 8, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Facile',
    question: "Romains 8:28 dit que toutes choses concourent au bien de ceux qui ___",
    options: ["observent la loi", "aiment Dieu", "prient chaque jour", "jeûnent"], correct: 1,
    explication: "Romains 8:28 : 'Toutes choses concourent au bien de ceux qui aiment Dieu.'" },

  { id: 9, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Facile',
    question: "Dans Romains 12:1, Paul exhorte les croyants a présenter leurs corps comme ___",
    options: ["un sacrifice vivant", "une offrande d'or", "un temple bati", "une lumiere brillante"], correct: 0,
    explication: "Romains 12:1 : 'Offrez vos corps comme un sacrifice vivant, saint, agréable a Dieu, ce qui sera de votre part un culte raisonnable.'" },

  { id: 10, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Facile',
    question: "Dans Romains 12:2, Paul nous demande de ne pas nous conformer a ___",
    options: ["la grace", "ce siecle", "la loi", "l'Église"], correct: 1,
    explication: "Romains 12:2 : 'Ne vous conformez pas au siecle présent, mais soyez transformés par le renouvellement de l'intelligence.'" },

  { id: 11, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Dans Romains 4, quel patriarche Paul cite-t-il comme modele de la justification par la foi ?",
    options: ["Moise", "David", "Abraham", "Noé"], correct: 2,
    explication: "Paul cite Abraham dans Romains 4 : sa foi lui fut imputée a justice avant même la circoncision." },

  { id: 12, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Moyen',
    question: "Selon Romains 5:8, quand Christ est-il mort pour nous ?",
    options: ["Quand nous étions justes", "Quand nous cherchions Dieu", "Quand nous étions encore pécheurs", "Quand nous étions baptisés"], correct: 2,
    explication: "Romains 5:8 : 'Dieu prouve son amour envers nous en ce que Christ est mort pour nous alors que nous étions encore pécheurs.'" },

  { id: 13, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Dans Romains 5, avec qui Paul compare-t-il Jésus comme figure typologique ?",
    options: ["Moise", "David", "Adam", "Noé"], correct: 2,
    explication: "Romains 5:12-21 compare Adam (qui apporta le péché) a Jésus-Christ (qui apporte la grace et la vie)." },

  { id: 14, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Romains 6 enseigne que le baptême nous unit a Christ dans ___",
    options: ["sa naissance", "sa mort et sa résurrection", "sa transfiguration", "son ascension"], correct: 1,
    explication: "Romains 6:4 : 'Nous avons donc été ensevelis avec lui par le baptême en sa mort... nous vivrons aussi d'une nouvelle vie.'" },

  { id: 15, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Moyen',
    question: "Romains 6:14 dit que le péché n'aura pas de pouvoir sur vous car vous n'êtes pas sous la loi mais sous ___",
    options: ["la vérité", "la grace", "l'amour", "la sagesse"], correct: 1,
    explication: "Romains 6:14 : 'Car le péché n'aura point de pouvoir sur vous, parce que vous êtes, non sous la loi, mais sous la grace.'" },

  { id: 16, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Dans Romains 7, Paul décrit un conflit intérieur entre quoi et quoi ?",
    options: ["L'amour et la haine", "La chair et l'esprit", "La loi et la grace", "La foi et les oeuvres"], correct: 1,
    explication: "Romains 7 illustre le conflit entre la chair (nature pécheresse) et le désir de faire le bien selon Dieu." },

  { id: 17, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Selon Romains 8:1, il n'y a maintenant aucune condamnation pour ceux qui sont ___",
    options: ["baptisés", "en Christ Jésus", "dans l'Église", "sous la loi"], correct: 1,
    explication: "Romains 8:1 : 'Il n'y a donc maintenant aucune condamnation pour ceux qui sont en Jésus-Christ.'" },

  { id: 18, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Dans Romains 8, l'Esprit Saint intercede pour nous avec ___",
    options: ["des paroles éloquentes", "des gemissements ineffables", "des chants de louange", "des prophéties"], correct: 1,
    explication: "Romains 8:26 : 'L'Esprit intercede par des soupirs ineffables pour nous qui ne savons pas prier comme il faut.'" },

  { id: 19, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Romains 10:17 dit que la foi vient de ___",
    options: ["la priere", "la predication", "ce qu'on entend", "la lecture"], correct: 2,
    explication: "Romains 10:17 : 'Ainsi la foi vient de ce qu'on entend, et ce qu'on entend vient de la parole de Christ.'" },

  { id: 20, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Dans Romains 9 a 11, Paul aborde principalement le sujet de ___",
    options: ["La priere", "Le mariage", "Le dessein de Dieu pour Israel", "Les dons spirituels"], correct: 2,
    explication: "Romains 9-11 traitent de la souveraineté de Dieu, de l'élection et du plan de salut pour Israel et les nations." },

  { id: 21, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Moyen',
    question: "Selon Romains 11:33, Paul s'exclame que les jugements de Dieu sont ___",
    options: ["simples et clairs", "insondables et incompréhensibles", "séveres et definitifs", "doux et miséricordieux"], correct: 1,
    explication: "Romains 11:33 : 'O profondeur de la richesse, de la sagesse et de la science de Dieu ! Que ses jugements sont insondables et ses voies incompréhensibles !'" },

  { id: 22, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Dans Romains 12, Paul dit que l'amour doit être ___",
    options: ["fort et puissant", "sans hypocrisie", "visible aux autres", "accompagné de dons"], correct: 1,
    explication: "Romains 12:9 : 'Que l'amour soit sans hypocrisie. Ayez le mal en horreur, attachez-vous au bien.'" },

  { id: 23, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Romains 13 enseigne que nous devons être soumis aux ___",
    options: ["anciens de l'Église", "autorités gouvernantes", "apotres seulement", "parents"], correct: 1,
    explication: "Romains 13:1 : 'Que toute personne soit soumise aux autorités supérieures, car il n'y a pas d'autorité qui ne vienne de Dieu.'" },

  { id: 24, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Dans Romains 14, Paul parle de l'attitude a avoir envers les croyants ___",
    options: ["riches", "faibles dans la foi", "qui ne prient pas", "qui ne jeûnent pas"], correct: 1,
    explication: "Romains 14 traite de l'accueil des freres faibles dans la foi, sans juger leurs convictions sur les jours ou la nourriture." },

  { id: 25, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Selon Romains 1:16, Paul n'a pas honte de l'Évangile car c'est une puissance de Dieu pour ___",
    options: ["les miracles", "le salut de quiconque croit", "la guérison des malades", "la prosperité"], correct: 1,
    explication: "Romains 1:16 : 'Je n'ai pas honte de l'Évangile, car c'est une puissance de Dieu pour le salut de quiconque croit.'" },

  { id: 26, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Difficile',
    question: "Dans Romains 4:3, Paul cite quel texte de l'Ancien Testament pour parler d'Abraham ?",
    options: ["Genese 12", "Genese 15:6", "Genese 22", "Deuteronome 6"], correct: 1,
    explication: "Romains 4:3 cite Genese 15:6 : 'Abraham crut a Dieu, et cela lui fut imputé a justice.'" },

  { id: 27, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Difficile',
    question: "Romains 3:21 parle d'une justice de Dieu manifestée en dehors de ___",
    options: ["la grace", "la loi", "la foi", "l'amour"], correct: 1,
    explication: "Romains 3:21 : 'Maintenant sans la loi est manifestée la justice de Dieu, attestée par la loi et les prophetes.'" },

  { id: 28, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "Dans Romains 3, quelle expression grecque Paul utilise-t-il pour désigner le moyen d'expiation (traduit par propitiatoire ou sacrifice d'expiation) ?",
    options: ["Logos", "Hilasterion", "Kurios", "Pneuma"], correct: 1,
    explication: "En Romains 3:25, le terme grec 'hilasterion' désigne Jésus comme sacrifice d'expiation ou propitiatoire, reference a l'arche d'alliance." },

  { id: 29, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Difficile',
    question: "Romains 8:29 parle de ceux que Dieu a foreconnus, disant qu'ils sont aussi ___",
    options: ["elus", "prédestinés a être conformes a l'image de son Fils", "sauvés par avance", "protégés des épreuves"], correct: 1,
    explication: "Romains 8:29 : 'Car ceux qu'il a foreconnus, il les a aussi prédestinés a être conformes a l'image de son Fils.'" },

  { id: 30, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Difficile',
    question: "Dans Romains 5, Paul dit que la ou le péché a abondé, la grace a ___",
    options: ["diminué", "surabondé", "été retirée", "été cachée"], correct: 1,
    explication: "Romains 5:20 : 'La ou le péché a abondé, la grace a surabondé.' Paul anticipe l'objection en Romains 6:1." },

  { id: 31, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Difficile',
    question: "Quel prophete de l'Ancien Testament Paul cite-t-il dans Romains 1:17 pour parler du juste vivant par la foi ?",
    options: ["Esaïe", "Jeremie", "Habacuc", "Malachie"], correct: 2,
    explication: "Romains 1:17 cite Habacuc 2:4 : 'Le juste vivra par la foi.' Ce verset a notamment inspire la Reforme protestante." },

  { id: 32, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "Romains 9:13 cite quel passage pour dire 'J'ai aimé Jacob et j'ai haï Esaü' ?",
    options: ["Genese 25", "Esaïe 40", "Malachie 1", "Deuteronome 7"], correct: 2,
    explication: "Romains 9:13 cite Malachie 1:2-3 pour illustrer la souveraineté de l'élection divine." },

  { id: 33, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Difficile',
    question: "Dans Romains 11, Paul utilise l'image d'un olivier pour expliquer quoi ?",
    options: ["La croissance de l'Église", "L'integration des Gentils dans le peuple de Dieu", "La richesse spirituelle", "La puissance de la priere"], correct: 1,
    explication: "Romains 11:17-24 : Paul compare Israel a un olivier franc et les Gentils a des rameaux sauvages greffés dessus." },

  { id: 34, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Difficile',
    question: "Dans Romains 12:19, Paul dit de ne pas se venger car 'c'est a moi qu'appartient la vengeance, c'est moi qui rétribuerai'. D'ou vient cette citation ?",
    options: ["Les Psaumes", "Esaïe", "Le Deuteronome", "Les Proverbes"], correct: 2,
    explication: "Romains 12:19 cite Deuteronome 32:35. Paul appuie son enseignement sur la non-vengeance par l'Écriture." },

  { id: 35, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Difficile',
    question: "Selon Romains 4, pourquoi la promesse est-elle fondée sur la grace et non sur la loi ?",
    options: ["Pour que tous les hommes puissent la mériter", "Afin qu'elle soit sure pour toute la postérité d'Abraham", "Pour que les Gentils soient exclus", "Pour honorer la tradition juive"], correct: 1,
    explication: "Romains 4:16 : 'C'est pourquoi on herite par la foi, afin que ce soit par grace, et pour que la promesse soit assurée a toute la postérité d'Abraham.'" },

  { id: 36, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "Romains 8:38-39 liste des choses qui ne peuvent séparer le croyant de l'amour de Dieu. Laquelle n'est PAS mentionnée ?",
    options: ["La mort", "Le péché", "Les anges", "Les puissances"], correct: 1,
    explication: "Romains 8:38-39 mentionne : la mort, la vie, les anges, les dominations, le présent, l'avenir, les puissances, la hauteur, la profondeur. Le péché n'est pas dans cette liste." },

  { id: 37, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Difficile',
    question: "Romains 3:10 cite l'Ancien Testament pour dire qu'il n'y a ___",
    options: ["aucun sage", "pas de juste, pas même un seul", "personne qui prie", "aucun prophete"], correct: 1,
    explication: "Romains 3:10 cite les Psaumes : 'Il n'y a pas de juste, pas même un seul' - établissant l'universalité du péché." },

  { id: 38, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Difficile',
    question: "Dans Romains 15, Paul présente son ambition missionnaire qui est de prêcher la ou Christ ___",
    options: ["est né", "a été crucifié", "n'avait pas été nommé", "est apparu en premier"], correct: 2,
    explication: "Romains 15:20 : 'J'ai mis mon ambition a annoncer l'Évangile la ou Christ n'avait pas encore été nommé.'" },

  { id: 39, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "Dans Romains 16, Paul mentionne Phebeé. Quel est son role ?",
    options: ["Prophetesse", "Diaconesse de l'Église de Cenchrées", "Femme d'un apotre", "Enseignante a Rome"], correct: 1,
    explication: "Romains 16:1 : 'Je vous recommande Phébée, notre soeur, qui est diaconesse de l'Église de Cenchrées.'" },

  { id: 40, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Difficile',
    question: "Romains 11:29 dit que les dons et l'appel de Dieu sont ___",
    options: ["temporaires", "conditionnels", "sans repentance (irrévocables)", "réservés a Israel"], correct: 2,
    explication: "Romains 11:29 : 'Car les dons et l'appel de Dieu sont sans repentance.' Ils sont irrévocables." },

  { id: 41, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Selon Romains 1:20, depuis la création du monde, qu'est-ce qui permet aux hommes de connaître Dieu ?",
    options: ["La Bible", "Les prophetes", "Les choses visibles de la nature", "Les rêves"], correct: 2,
    explication: "Romains 1:20 : 'Les perfections invisibles de Dieu, sa puissance éternelle et sa divinité, se voient depuis la création du monde dans ses oeuvres.'" },

  { id: 42, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Facile',
    question: "Dans Romains 13:8, Paul dit de ne rien devoir a personne, sinon de ___",
    options: ["prier pour eux", "s'aimer les uns les autres", "partager ses biens", "servir l'Église"], correct: 1,
    explication: "Romains 13:8 : 'Ne devez rien a personne, sinon de vous aimer les uns les autres, car celui qui aime les autres a accompli la loi.'" },

  { id: 43, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Romains 10:13 dit que quiconque ___ sera sauvé.",
    options: ["jeûnera", "invoquera le nom du Seigneur", "se fera baptiser", "fera de bonnes oeuvres"], correct: 1,
    explication: "Romains 10:13 : 'Car quiconque invoquera le nom du Seigneur sera sauvé.' Citation de Joel 2:32." },

  { id: 44, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Moyen',
    question: "Dans Romains 5, Paul dit que nous nous glorifions même dans les afflictions car elles produisent finalement ___",
    options: ["la richesse", "l'espérance", "les miracles", "la sagesse"], correct: 1,
    explication: "Romains 5:3-4 : 'L'affliction produit la patience, la patience la persévérance, la persévérance l'espérance.'" },

  { id: 45, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Selon Romains 12:20, si ton ennemi a faim, que dois-tu faire ?",
    options: ["L'éviter", "Le nourrir", "Le reprendre", "Prier pour lui seulement"], correct: 1,
    explication: "Romains 12:20 : 'Si ton ennemi a faim, donne-lui a manger ; s'il a soif, donne-lui a boire.' Citation des Proverbes 25:21." },

  { id: 46, livre: 'Romains', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Dans Romains 4, Paul dit qu'Abraham a cru en Dieu qui ___ les morts.",
    options: ["ressuscite", "juge", "pardonne", "bénit"], correct: 0,
    explication: "Romains 4:17 : 'Abraham crut en Dieu qui donne la vie aux morts et qui appelle les choses qui ne sont pas comme si elles étaient.'" },

  { id: 47, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Romains 8:2 parle de la loi de l'Esprit de vie en Christ Jésus qui nous a affranchis de ___",
    options: ["la mort éternelle", "la loi du péché et de la mort", "la puissance de Satan", "la condamnation du monde"], correct: 1,
    explication: "Romains 8:2 : 'La loi de l'Esprit de vie en Jésus-Christ m'a affranchi de la loi du péché et de la mort.'" },

  { id: 48, livre: 'Romains', testament: 'Nouveau', theme: 'Grâce', difficulte: 'Facile',
    question: "Romains 5:1 dit que la justification par la foi nous donne la ___ avec Dieu.",
    options: ["joie", "richesse", "paix", "sagesse"], correct: 2,
    explication: "Romains 5:1 : 'Etant donc justifiés par la foi, nous avons la paix avec Dieu par notre Seigneur Jésus-Christ.'" },

  { id: 49, livre: 'Romains', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Facile',
    question: "Dans Romains 12:15, Paul dit de se réjouir avec ceux qui se réjouissent et de ___",
    options: ["chanter avec ceux qui chantent", "pleurer avec ceux qui pleurent", "jeûner avec ceux qui jeûnent", "prier avec ceux qui prient"], correct: 1,
    explication: "Romains 12:15 : 'Réjouissez-vous avec ceux qui se réjouissent, pleurez avec ceux qui pleurent.'" },

  { id: 50, livre: 'Romains', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "Dans Romains 16, quel compagnon de Paul est désigné comme celui qui a transcrit l'épitre ?",
    options: ["Luc", "Tertius", "Timothée", "Silas"], correct: 1,
    explication: "Romains 16:22 : 'Moi, Tertius, qui ai écrit cette épitre, je vous salue dans le Seigneur.'" },

  // ══════════════════ LIVRE : JEAN ══════════════════
  { id: 11, livre: 'Jean', testament: 'Nouveau', theme: 'Amour', difficulte: 'Facile',
    question: "Quel est le verset le plus connu de l'Évangile de Jean sur l'amour de Dieu ?",
    options: ["Jean 1:1", "Jean 3:16", "Jean 11:35", "Jean 14:6"], correct: 1,
    explication: "Jean 3:16 : 'Car Dieu a tant aimé le monde qu'il a donné son Fils unique.'" },

  { id: 12, livre: 'Jean', testament: 'Nouveau', theme: 'Foi', difficulte: 'Facile',
    question: "Dans Jean 14:6, Jésus dit 'Je suis le chemin, la vérité et ___'",
    options: ["la lumiere", "la vie", "la porte", "le pain"], correct: 1,
    explication: "Jean 14:6 : 'Je suis le chemin, la vérité et la vie. Nul ne vient au Pere que par moi.'" },

  { id: 13, livre: 'Jean', testament: 'Nouveau', theme: 'Miracles', difficulte: 'Facile',
    question: "Quel fut le premier miracle de Jésus selon l'Évangile de Jean ?",
    options: ["Guérison d'un aveugle", "Marcher sur l'eau", "Transformer l'eau en vin", "Multiplication des pains"], correct: 2,
    explication: "Jean 2 : Jésus transforma l'eau en vin lors des noces de Cana - son premier signe." },

  { id: 14, livre: 'Jean', testament: 'Nouveau', theme: 'Miracles', difficulte: 'Moyen',
    question: "Qui Jésus a-t-il ressuscité dans Jean 11 ?",
    options: ["Jaïrus", "Lazare", "Le fils de la veuve", "Tabitha"], correct: 1,
    explication: "Jean 11 : Jésus ressuscita Lazare, frere de Marie et Marthe, après 4 jours dans le tombeau." },

  { id: 15, livre: 'Jean', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Selon Jean 1:1, qui était 'au commencement' ?",
    options: ["L'Esprit", "La Parole (Logos)", "Les anges", "Abraham"], correct: 1,
    explication: "Jean 1:1 : 'Au commencement était la Parole, et la Parole était avec Dieu, et la Parole était Dieu.'" },

  { id: 16, livre: 'Jean', testament: 'Nouveau', theme: 'Amour', difficulte: 'Difficile',
    question: "Combien de fois Pierre affirme-t-il son amour a Jésus dans Jean 21 ?",
    options: ["1 fois", "2 fois", "3 fois", "7 fois"], correct: 2,
    explication: "Jean 21 : Jésus interroge Pierre 3 fois - rappelant les 3 reniements - et Pierre affirme 3 fois son amour." },

  { id: 17, livre: 'Jean', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Dans Jean 20, quel disciple refusa de croire a la résurrection sans toucher Jésus ?",
    options: ["Pierre", "Jean", "Thomas", "Philippe"], correct: 2,
    explication: "Thomas dit : 'Si je ne vois pas la marque des clous... je ne croirai pas.' (Jean 20:25)" },

  { id: 18, livre: 'Jean', testament: 'Nouveau', theme: 'Miracles', difficulte: 'Difficile',
    question: "Combien de signes (miracles) l'Évangile de Jean relate-t-il principalement ?",
    options: ["5", "6", "7", "10"], correct: 2,
    explication: "L'Évangile de Jean structure son récit autour de 7 signes miraculeux de Jésus." },

  { id: 19, livre: 'Jean', testament: 'Nouveau', theme: 'Salut', difficulte: 'Difficile',
    question: "A qui Jésus parle-t-il de la 'nouvelle naissance' dans Jean 3 ?",
    options: ["Marie-Madeleine", "Nicodeme", "La Samaritaine", "Pilate"], correct: 1,
    explication: "Jean 3 : Jésus explique a Nicodeme, un pharisien, la nécessité de naître de nouveau." },

  { id: 20, livre: 'Jean', testament: 'Nouveau', theme: 'Amour', difficulte: 'Facile',
    question: "Quel est le verset le plus court de la Bible ?",
    options: ["Jean 3:16", "Jean 11:35", "Jean 1:1", "Jean 14:1"], correct: 1,
    explication: "Jean 11:35 : 'Jésus pleura.' - le verset le plus court de la Bible." },

  // ══════════════════ LIVRE : GENÈSE ══════════════════
  { id: 21, livre: 'Genese', testament: 'Ancien', theme: 'Création', difficulte: 'Facile',
    question: "Combien de jours Dieu a-t-il mis pour créer le monde selon la Genese ?",
    options: ["5 jours", "6 jours", "7 jours", "10 jours"], correct: 1,
    explication: "Dieu créa en 6 jours et se reposa le 7eme jour (Genese 1-2)." },

  { id: 22, livre: 'Genese', testament: 'Ancien', theme: 'Création', difficulte: 'Facile',
    question: "Comment s'appelait le premier homme selon la Genese ?",
    options: ["Noé", "Adam", "Abraham", "Caïn"], correct: 1,
    explication: "Adam fut le premier homme créé par Dieu a partir de la poussiere du sol (Genese 2)." },

  { id: 23, livre: 'Genese', testament: 'Ancien', theme: 'Foi', difficulte: 'Moyen',
    question: "Quel signe Dieu donna-t-il a Noé apres le déluge ?",
    options: ["Une étoile", "Un arc-en-ciel", "Une colombe", "Un vent"], correct: 1,
    explication: "Dieu plaça un arc-en-ciel dans les nuages comme signe de son alliance avec Noé (Genese 9)." },

  { id: 24, livre: 'Genese', testament: 'Ancien', theme: 'Foi', difficulte: 'Moyen',
    question: "Combien d'années Abraham avait-il a la naissance d'Isaac ?",
    options: ["70 ans", "80 ans", "90 ans", "100 ans"], correct: 3,
    explication: "Abraham avait 100 ans a la naissance d'Isaac (Genese 21:5)." },

  { id: 25, livre: 'Genese', testament: 'Ancien', theme: 'Création', difficulte: 'Difficile',
    question: "Quel était le nom du jardin ou vivaient Adam et Eve ?",
    options: ["Eden", "Canaan", "Goshen", "Shinar"], correct: 0,
    explication: "Le jardin d'Eden était le lieu ou Dieu plaça Adam et Eve (Genese 2)." },

  { id: 26, livre: 'Genese', testament: 'Ancien', theme: 'Foi', difficulte: 'Difficile',
    question: "Combien de fils Jacob avait-il en tout ?",
    options: ["10", "11", "12", "13"], correct: 2,
    explication: "Jacob eut 12 fils, qui devinrent les peres des 12 tribus d'Israel." },

  { id: 27, livre: 'Genese', testament: 'Ancien', theme: 'Création', difficulte: 'Moyen',
    question: "Qu'est-ce que Caïn fit a Abel son frere ?",
    options: ["Il le vendit", "Il le tua", "Il le chassa", "Il le trompa"], correct: 1,
    explication: "Caïn, jaloux, tua son frere Abel - le premier meurtre de l'humanité (Genese 4)." },

  { id: 28, livre: 'Genese', testament: 'Ancien', theme: 'Foi', difficulte: 'Moyen',
    question: "Quelle tour construisait-on pour atteindre le ciel dans Genese 11 ?",
    options: ["Tour de Babylone", "Tour de Sodome", "Tour de Babel", "Tour de Ninive"], correct: 2,
    explication: "La tour de Babel : les hommes voulaient batir une tour jusqu'au ciel (Genese 11)." },

  { id: 29, livre: 'Genese', testament: 'Ancien', theme: 'Création', difficulte: 'Difficile',
    question: "Pendant combien de jours et de nuits plut-il lors du déluge ?",
    options: ["20 jours", "30 jours", "40 jours", "50 jours"], correct: 2,
    explication: "Il plut 40 jours et 40 nuits lors du déluge de Noé (Genese 7:12)." },

  { id: 30, livre: 'Genese', testament: 'Ancien', theme: 'Foi', difficulte: 'Facile',
    question: "Joseph, fils de Jacob, fut vendu comme esclave dans quel pays ?",
    options: ["Babylone", "Egypte", "Canaan", "Assyrie"], correct: 1,
    explication: "Joseph fut vendu a des marchands ismaélites qui l'emmenèrent en Egypte (Genese 37)." },

  // ══════════════════ LIVRE : PSAUMES ══════════════════
  { id: 31, livre: 'Psaumes', testament: 'Ancien', theme: 'Prière', difficulte: 'Facile',
    question: "Le Psaume 23 commence par : 'L'Éternel est mon ___'",
    options: ["rocher", "berger", "bouclier", "lumiere"], correct: 1,
    explication: "Le Psaume 23, attribué a David, commence par 'L'Éternel est mon berger'." },

  { id: 32, livre: 'Psaumes', testament: 'Ancien', theme: 'Louange', difficulte: 'Facile',
    question: "Combien de Psaumes contient le livre des Psaumes ?",
    options: ["100", "120", "150", "175"], correct: 2,
    explication: "Le livre des Psaumes contient 150 psaumes." },

  { id: 33, livre: 'Psaumes', testament: 'Ancien', theme: 'Foi', difficulte: 'Moyen',
    question: "Quel Psaume commence par 'Dieu est notre refuge et notre force' ?",
    options: ["Psaume 23", "Psaume 46", "Psaume 91", "Psaume 121"], correct: 1,
    explication: "Psaume 46:1 : 'Dieu est notre refuge et notre force, un secours qui ne manque jamais dans la détresse.'" },

  { id: 34, livre: 'Psaumes', testament: 'Ancien', theme: 'Prière', difficulte: 'Moyen',
    question: "Quel Psaume dit 'Ta parole est une lampe a mes pieds' ?",
    options: ["Psaume 1", "Psaume 19", "Psaume 119", "Psaume 150"], correct: 2,
    explication: "Psaume 119:105 : 'Ta parole est une lampe a mes pieds et une lumiere sur mon sentier.'" },

  { id: 35, livre: 'Psaumes', testament: 'Ancien', theme: 'Louange', difficulte: 'Difficile',
    question: "Quel est le Psaume le plus long de la Bible ?",
    options: ["Psaume 91", "Psaume 103", "Psaume 119", "Psaume 150"], correct: 2,
    explication: "Le Psaume 119 est le plus long avec 176 versets, organisé en 22 strophes." },

  { id: 36, livre: 'Psaumes', testament: 'Ancien', theme: 'Prière', difficulte: 'Difficile',
    question: "Le Psaume 22 commence par des mots que Jésus a prononcés sur la croix. Lesquels ?",
    options: ["Pere, pardonne-leur", "Mon Dieu, pourquoi m'as-tu abandonné ?", "Tout est accompli", "Je remets mon esprit"], correct: 1,
    explication: "Psaume 22:1 cité par Jésus en Marc 15:34 : 'Mon Dieu, mon Dieu, pourquoi m'as-tu abandonné ?'" },

  // ══════════════════ THÈME : PRIÈRE ══════════════════
  { id: 37, livre: 'Matthieu', testament: 'Nouveau', theme: 'Prière', difficulte: 'Facile',
    question: "Dans quel chapitre de Matthieu trouve-t-on le Notre Pere ?",
    options: ["Matthieu 4", "Matthieu 6", "Matthieu 8", "Matthieu 10"], correct: 1,
    explication: "Le Notre Pere se trouve dans Matthieu 6:9-13, au coeur du Sermon sur la Montagne." },

  { id: 38, livre: 'Luc', testament: 'Nouveau', theme: 'Prière', difficulte: 'Moyen',
    question: "Jésus alla prier au jardin de ___ avant son arrestation.",
    options: ["Gethsemane", "Eden", "Siloe", "Bethanie"], correct: 0,
    explication: "Jésus pria avec angoisse au jardin de Gethsemane avant d'être arrêté (Luc 22:39-46)." },

  { id: 39, livre: 'Philippiens', testament: 'Nouveau', theme: 'Prière', difficulte: 'Moyen',
    question: "Philippiens 4:6 nous invite a présenter nos requêtes a Dieu avec ___",
    options: ["des sacrifices", "des jeûnes", "des actions de graces", "des larmes"], correct: 2,
    explication: "Philippiens 4:6 : 'En toutes choses, par des prieres et des supplications avec des actions de graces.'" },

  // ══════════════════ THÈME : FOI ══════════════════
  { id: 40, livre: 'Hebreux', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Hebreux 11:1 définit la foi comme l'assurance des choses qu'on espere et ___",
    options: ["la preuve de l'amour", "la démonstration des choses qu'on ne voit pas", "le fondement de la grace", "la certitude du salut"], correct: 1,
    explication: "Hebreux 11:1 : 'Or la foi, c'est la substance des choses qu'on espere, la démonstration de celles qu'on ne voit pas.'" },

  { id: 41, livre: 'Jacques', testament: 'Nouveau', theme: 'Foi', difficulte: 'Moyen',
    question: "Jacques dit que la foi sans les oeuvres est ___",
    options: ["suffisante", "morte", "faible", "imparfaite"], correct: 1,
    explication: "Jacques 2:17 : 'Ainsi la foi, si elle n'a pas les oeuvres, est morte en elle-même.'" },

  // ══════════════════ THÈME : SALUT ══════════════════
  { id: 42, livre: 'Ephesiens', testament: 'Nouveau', theme: 'Salut', difficulte: 'Facile',
    question: "Ephesiens 2:8 dit que vous êtes sauvés par la grace, par le moyen de ___",
    options: ["l'amour", "la loi", "la foi", "les oeuvres"], correct: 2,
    explication: "Ephesiens 2:8 : 'C'est par la grace que vous êtes sauvés, par le moyen de la foi.'" },

  { id: 43, livre: 'Actes', testament: 'Nouveau', theme: 'Salut', difficulte: 'Moyen',
    question: "Dans Actes 2, combien de personnes furent baptisées lors de la Pentecôte ?",
    options: ["120", "500", "3000", "5000"], correct: 2,
    explication: "Actes 2:41 : Environ 3000 personnes furent baptisées lors de la premiere Pentecôte chrétienne." },

  // ══════════════════ THÈME : LOUANGE ══════════════════
  { id: 44, livre: 'Apocalypse', testament: 'Nouveau', theme: 'Louange', difficulte: 'Difficile',
    question: "Dans Apocalypse 4, les 4 etres vivants répetent sans cesse ___",
    options: ["Alléluia", "Saint, saint, saint est le Seigneur", "Gloire a Dieu", "Amen"], correct: 1,
    explication: "Apocalypse 4:8 : Les quatre etres vivants répetent sans cesse 'Saint, saint, saint est le Seigneur Dieu tout-puissant.'" },

  { id: 45, livre: 'Psaumes', testament: 'Ancien', theme: 'Louange', difficulte: 'Facile',
    question: "Le Psaume 150 se termine par 'Que tout ce qui respire ___'",
    options: ["adore le Seigneur", "loue l'Éternel", "chante sa gloire", "cherche sa face"], correct: 1,
    explication: "Psaume 150:6 : 'Que tout ce qui respire loue l'Éternel !' - la conclusion du psautier." },

  // ══════════════════ THÈME : VIE CHRÉTIENNE ══════════════════
  { id: 46, livre: 'Galates', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Quel est le premier fruit de l'Esprit cité dans Galates 5:22 ?",
    options: ["La paix", "La joie", "L'amour", "La bonté"], correct: 2,
    explication: "Galates 5:22 : 'Le fruit de l'Esprit, c'est : l'amour, la joie, la paix...' - l'amour est cité en premier." },

  { id: 47, livre: 'Ephesiens', testament: 'Nouveau', theme: 'Vie chrétienne', difficulte: 'Moyen',
    question: "Dans Ephesiens 6, quelle piece de l'armure protege la tête ?",
    options: ["Le bouclier de la foi", "La cuirasse de justice", "Le casque du salut", "La ceinture de vérité"], correct: 2,
    explication: "Ephesiens 6:17 : 'Prenez aussi le casque du salut et l'épée de l'Esprit qui est la Parole de Dieu.'" },

  { id: 48, livre: '1 Corinthiens', testament: 'Nouveau', theme: 'Amour', difficulte: 'Facile',
    question: "Dans 1 Corinthiens 13, Paul dit que l'amour ne ___",
    options: ["grandit pas", "passe jamais", "se manifeste pas", "suffit pas"], correct: 1,
    explication: "1 Corinthiens 13:8 : 'L'amour ne passe jamais.' Il est supérieur a tous les dons spirituels." },

  { id: 49, livre: 'Proverbes', testament: 'Ancien', theme: 'Sagesse', difficulte: 'Facile',
    question: "Proverbes 3:5 dit de se confier en l'Éternel de tout son coeur et de ne pas s'appuyer sur ___",
    options: ["les autres", "les richesses", "sa propre sagesse", "la loi"], correct: 2,
    explication: "Proverbes 3:5 : 'Confie-toi en l'Éternel de tout ton coeur et ne t'appuie pas sur ta propre intelligence.'" },

  { id: 50, livre: 'Esaïe', testament: 'Ancien', theme: 'Foi', difficulte: 'Moyen',
    question: "Esaïe 40:31 dit que ceux qui se confient en l'Éternel renouvellent leurs forces et prennent le vol comme ___",
    options: ["des colombes", "des aigles", "des hirondelles", "des anges"], correct: 1,
    explication: "Esaïe 40:31 : 'Ceux qui se confient en l'Éternel renouvellent leurs forces. Ils prennent le vol comme des aigles.'" },
];

// ─── CONFIGURATION DES FILTRES ─────────────────────────────────────────────────
const LIVRES = [...new Set(QUESTION_LIBRARY.map(q => q.livre))].sort();
const THEMES = [...new Set(QUESTION_LIBRARY.map(q => q.theme))].sort();
const TESTAMENTS = ['Ancien', 'Nouveau'];
const DIFFICULTES = ['Facile', 'Moyen', 'Difficile'];
const TIMER_DURATION = 7;

const Quiz = () => {
  const [phase, setPhase] = useState('selection');
  const [filters, setFilters] = useState({ testament: '', livre: '', theme: '', difficulte: '' });
  const [questions, setQuestions] = useState([]);
  const [currentQ, setCurrentQ] = useState(0);
  const [selected, setSelected] = useState(null);
  const [timeLeft, setTimeLeft] = useState(TIMER_DURATION);
  const [answers, setAnswers] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const timerRef = useRef(null);
  const feedbackRef = useRef(null);

  const filteredQuestions = QUESTION_LIBRARY.filter(q => {
    if (filters.testament && q.testament !== filters.testament) return false;
    if (filters.livre && q.livre !== filters.livre) return false;
    if (filters.theme && q.theme !== filters.theme) return false;
    if (filters.difficulte && q.difficulte !== filters.difficulte) return false;
    return true;
  });

  const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);

  const nextQuestion = useCallback((idx) => {
    clearTimeout(feedbackRef.current);
    clearInterval(timerRef.current);
    if (idx + 1 >= questions.length) {
      setPhase('finished');
    } else {
      setCurrentQ(idx + 1);
      setSelected(null);
      setShowFeedback(false);
      setTimeLeft(TIMER_DURATION);
    }
  }, [questions.length]);

  useEffect(() => {
    if (phase !== 'playing' || showFeedback) return;
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          setAnswers(prev => [...prev, { questionIndex: currentQ, selected: null, correct: false }]);
          setShowFeedback(true);
          feedbackRef.current = setTimeout(() => nextQuestion(currentQ), 1800);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [phase, currentQ, showFeedback, nextQuestion]);

  const handleAnswer = (optionIndex) => {
    if (showFeedback) return;
    clearInterval(timerRef.current);
    const isCorrect = optionIndex === questions[currentQ].correct;
    setSelected(optionIndex);
    setAnswers(prev => [...prev, { questionIndex: currentQ, selected: optionIndex, correct: isCorrect }]);
    setShowFeedback(true);
    feedbackRef.current = setTimeout(() => nextQuestion(currentQ), 2000);
  };

  const startQuiz = () => {
    const pool = shuffle(filteredQuestions).slice(0, 10);
    setQuestions(pool);
    setPhase('playing');
    setCurrentQ(0);
    setSelected(null);
    setTimeLeft(TIMER_DURATION);
    setAnswers([]);
    setShowFeedback(false);
  };

  const score = answers.filter(a => a.correct).length;
  const timerPercent = (timeLeft / TIMER_DURATION) * 100;
  const timerColor = timeLeft <= 2 ? '#e74c3c' : timeLeft <= 4 ? '#f39c12' : '#A98667';
  const q = questions[currentQ];

  const FilterBtn = ({ field, value, label }) => {
    const active = filters[field] === value;
    return (
      <button
        className={`filter-btn ${active ? 'active' : ''}`}
        onClick={() => setFilters(f => ({ ...f, [field]: active ? '' : value }))}
      >
        {label}
      </button>
    );
  };

  return (
    <>
      <style>{`
        .quiz-page {
          min-height: 100vh;
          padding: 100px 24px 80px;
          background: linear-gradient(180deg, #1F2A44 0%, #141d30 100%);
          position: relative;
        }
        .quiz-page::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 60% 40% at 50% 0%, rgba(169,134,103,0.1), transparent 60%);
          pointer-events: none;
        }
        .quiz-header {
          max-width: 800px;
          margin: 0 auto 48px;
          text-align: center;
          animation: fadeInUp 0.5s ease;
        }
        .quiz-label {
          font-size: 0.8rem;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #A98667;
          margin-bottom: 12px;
        }
        .quiz-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 4vw, 3rem);
          color: #FFFFFF;
          margin-bottom: 12px;
        }
        .quiz-subtitle { color: rgba(240,234,226,0.55); font-size: 0.95rem; }
        .selection-container { max-width: 900px; margin: 0 auto; animation: fadeInUp 0.4s ease; }
        .filter-section {
          background: rgba(31,42,68,0.5);
          border: 1px solid rgba(169,134,103,0.15);
          border-radius: 20px;
          padding: 28px 32px;
          margin-bottom: 20px;
        }
        .filter-section-title {
          font-size: 0.78rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #A98667;
          margin-bottom: 16px;
        }
        .filter-grid { display: flex; flex-wrap: wrap; gap: 10px; }
        .filter-btn {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(169,134,103,0.2);
          border-radius: 50px;
          padding: 8px 18px;
          color: rgba(240,234,226,0.7);
          font-size: 0.875rem;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: 'Jost', sans-serif;
        }
        .filter-btn:hover { border-color: rgba(169,134,103,0.5); color: #FFFFFF; background: rgba(169,134,103,0.08); }
        .filter-btn.active { background: rgba(169,134,103,0.2); border-color: #A98667; color: #FFFFFF; }
        .quiz-count-bar {
          background: rgba(31,42,68,0.5);
          border: 1px solid rgba(169,134,103,0.15);
          border-radius: 16px;
          padding: 20px 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 24px;
          flex-wrap: wrap;
          gap: 16px;
        }
        .quiz-count-info { display: flex; align-items: center; gap: 12px; }
        .quiz-count-number { font-family: 'Cormorant Garamond', serif; font-size: 2.5rem; font-weight: 700; color: #A98667; line-height: 1; }
        .quiz-count-text { font-size: 0.875rem; color: rgba(240,234,226,0.6); line-height: 1.4; }
        .quiz-count-text strong { color: #FFFFFF; }
        .quiz-start-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #A98667, #c4a07d);
          color: #FFFFFF;
          border: none;
          border-radius: 50px;
          padding: 14px 32px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: 'Jost', sans-serif;
        }
        .quiz-start-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(169,134,103,0.4); }
        .quiz-start-btn:disabled { opacity: 0.4; cursor: not-allowed; }
        .reset-btn {
          background: none;
          border: 1px solid rgba(169,134,103,0.2);
          border-radius: 50px;
          color: rgba(240,234,226,0.55);
          font-size: 0.85rem;
          padding: 8px 16px;
          cursor: pointer;
          transition: all 0.2s;
          font-family: 'Jost', sans-serif;
        }
        .reset-btn:hover { color: #FFFFFF; border-color: rgba(169,134,103,0.4); }
        .quiz-play-container { max-width: 700px; margin: 0 auto; }
        .quiz-card {
          background: rgba(31,42,68,0.6);
          border: 1px solid rgba(169,134,103,0.2);
          border-radius: 24px;
          padding: 40px;
          animation: fadeInUp 0.3s ease;
        }
        .quiz-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
        .quiz-meta { display: flex; flex-direction: column; gap: 6px; }
        .quiz-progress-text { font-size: 0.85rem; font-weight: 600; color: rgba(240,234,226,0.5); }
        .quiz-tags { display: flex; gap: 6px; flex-wrap: wrap; }
        .quiz-tag {
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 0.8px;
          padding: 3px 10px;
          border-radius: 50px;
          background: rgba(169,134,103,0.12);
          color: #A98667;
          border: 1px solid rgba(169,134,103,0.2);
        }
        .timer-circle { width: 54px; height: 54px; position: relative; flex-shrink: 0; }
        .timer-svg { transform: rotate(-90deg); width: 54px; height: 54px; }
        .timer-bg { fill: none; stroke: rgba(255,255,255,0.06); stroke-width: 3; }
        .timer-arc { fill: none; stroke-width: 3; stroke-linecap: round; transition: stroke-dashoffset 0.9s linear, stroke 0.3s; }
        .timer-number { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 1.1rem; font-weight: 700; }
        .quiz-progress-bar { height: 3px; background: rgba(255,255,255,0.06); border-radius: 2px; margin-bottom: 28px; overflow: hidden; }
        .quiz-progress-fill { height: 100%; background: linear-gradient(90deg, #A98667, #c4a07d); border-radius: 2px; transition: width 0.3s ease; }
        .quiz-question { font-family: 'Cormorant Garamond', serif; font-size: 1.55rem; color: #FFFFFF; line-height: 1.4; margin-bottom: 28px; }
        .quiz-options { display: flex; flex-direction: column; gap: 10px; }
        .quiz-option {
          background: rgba(255,255,255,0.03);
          border: 1.5px solid rgba(169,134,103,0.18);
          border-radius: 12px;
          padding: 15px 18px;
          display: flex;
          align-items: center;
          gap: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: rgba(240,234,226,0.85);
          font-size: 0.95rem;
          text-align: left;
          width: 100%;
          font-family: 'Jost', sans-serif;
        }
        .quiz-option:hover:not(.disabled) { background: rgba(169,134,103,0.1); border-color: rgba(169,134,103,0.4); color: #FFFFFF; transform: translateX(4px); }
        .quiz-option.correct { background: rgba(39,174,96,0.15); border-color: #27ae60; color: #FFFFFF; }
        .quiz-option.wrong { background: rgba(231,76,60,0.15); border-color: #e74c3c; color: #FFFFFF; }
        .quiz-option.disabled { cursor: default; }
        .option-letter { width: 30px; height: 30px; border-radius: 50%; border: 1.5px solid rgba(169,134,103,0.35); display: flex; align-items: center; justify-content: center; font-size: 0.78rem; font-weight: 700; color: #A98667; flex-shrink: 0; transition: all 0.2s; }
        .quiz-option.correct .option-letter { background: #27ae60; border-color: #27ae60; color: #fff; }
        .quiz-option.wrong .option-letter { background: #e74c3c; border-color: #e74c3c; color: #fff; }
        .quiz-feedback { margin-top: 18px; padding: 14px 18px; border-radius: 10px; font-size: 0.875rem; line-height: 1.6; animation: fadeInUp 0.3s ease; }
        .quiz-feedback.correct { background: rgba(39,174,96,0.08); border: 1px solid rgba(39,174,96,0.2); color: rgba(240,234,226,0.85); }
        .quiz-feedback.wrong { background: rgba(231,76,60,0.08); border: 1px solid rgba(231,76,60,0.2); color: rgba(240,234,226,0.85); }
        .quiz-feedback.timeout { background: rgba(169,134,103,0.08); border: 1px solid rgba(169,134,103,0.2); color: rgba(240,234,226,0.7); }
        .quiz-results { max-width: 720px; margin: 0 auto; background: rgba(31,42,68,0.6); border: 1px solid rgba(169,134,103,0.2); border-radius: 24px; padding: 48px 40px; text-align: center; animation: fadeInUp 0.5s ease; }
        .results-score-circle { width: 140px; height: 140px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 28px; }
        .results-score-inner { width: 110px; height: 110px; border-radius: 50%; background: #1F2A44; display: flex; flex-direction: column; align-items: center; justify-content: center; }
        .results-score-number { font-family: 'Cormorant Garamond', serif; font-size: 2.8rem; font-weight: 700; color: #FFFFFF; line-height: 1; }
        .results-score-total { font-size: 0.85rem; color: rgba(240,234,226,0.45); }
        .results-title { font-family: 'Cormorant Garamond', serif; font-size: 2rem; color: #FFFFFF; margin-bottom: 8px; }
        .results-subtitle { color: rgba(240,234,226,0.55); margin-bottom: 32px; font-size: 0.975rem; }
        .results-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-bottom: 32px; }
        .results-stat { background: rgba(169,134,103,0.08); border: 1px solid rgba(169,134,103,0.12); border-radius: 12px; padding: 18px 12px; }
        .results-stat-number { font-family: 'Cormorant Garamond', serif; font-size: 1.8rem; font-weight: 700; color: #A98667; }
        .results-stat-label { font-size: 0.78rem; color: rgba(240,234,226,0.45); }
        .results-answers { text-align: left; margin-bottom: 32px; }
        .results-answer { display: flex; align-items: flex-start; gap: 10px; padding: 10px 0; border-bottom: 1px solid rgba(169,134,103,0.07); font-size: 0.85rem; }
        .answer-q { color: rgba(240,234,226,0.75); margin-bottom: 2px; }
        .answer-correct { color: rgba(240,234,226,0.4); font-size: 0.78rem; }
        .results-btns { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
        .btn-ghost { background: rgba(169,134,103,0.15); border: 1px solid rgba(169,134,103,0.25); }
        @media (max-width: 600px) {
          .quiz-card, .quiz-results { padding: 28px 20px; }
          .results-stats { grid-template-columns: 1fr; }
          .filter-section { padding: 20px; }
          .quiz-count-bar { flex-direction: column; align-items: flex-start; }
        }
      `}</style>

      <div className="quiz-page">
        <div className="quiz-header">
          <p className="quiz-label">Bibliotheque de questions</p>
          <h1 className="quiz-title">Quiz Biblique</h1>
          <p className="quiz-subtitle">{QUESTION_LIBRARY.length} questions - Filtre par livre, theme, testament ou difficulte</p>
        </div>

        {/* ── SELECTION ── */}
        {phase === 'selection' && (
          <div className="selection-container">
            <div className="filter-section">
              <p className="filter-section-title">Testament</p>
              <div className="filter-grid">
                {TESTAMENTS.map(t => <FilterBtn key={t} field="testament" value={t} label={`${t} Testament`} />)}
              </div>
            </div>
            <div className="filter-section">
              <p className="filter-section-title">Livre</p>
              <div className="filter-grid">
                {LIVRES.map(l => <FilterBtn key={l} field="livre" value={l} label={l} />)}
              </div>
            </div>
            <div className="filter-section">
              <p className="filter-section-title">Theme</p>
              <div className="filter-grid">
                {THEMES.map(t => <FilterBtn key={t} field="theme" value={t} label={t} />)}
              </div>
            </div>
            <div className="filter-section">
              <p className="filter-section-title">Difficulte</p>
              <div className="filter-grid">
                {DIFFICULTES.map(d => <FilterBtn key={d} field="difficulte" value={d} label={d} />)}
              </div>
            </div>
            <div className="quiz-count-bar">
              <div className="quiz-count-info">
                <span className="quiz-count-number">{filteredQuestions.length}</span>
                <div className="quiz-count-text">
                  question{filteredQuestions.length !== 1 ? 's' : ''} disponible{filteredQuestions.length !== 1 ? 's' : ''}<br />
                  <strong>{Math.min(filteredQuestions.length, 10)} seront tirees au sort</strong>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <button className="reset-btn" onClick={() => setFilters({ testament: '', livre: '', theme: '', difficulte: '' })}>
                  Reinitialiser
                </button>
                <button className="quiz-start-btn" onClick={startQuiz} disabled={filteredQuestions.length === 0}>
                  Commencer
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── PLAYING ── */}
        {phase === 'playing' && q && (
          <div className="quiz-play-container">
            <div className="quiz-card">
              <div className="quiz-top">
                <div className="quiz-meta">
                  <span className="quiz-progress-text">Question {currentQ + 1} / {questions.length}</span>
                  <div className="quiz-tags">
                    <span className="quiz-tag">{q.livre}</span>
                    <span className="quiz-tag">{q.theme}</span>
                    <span className="quiz-tag">{q.difficulte}</span>
                  </div>
                </div>
                <div className="timer-circle">
                  <svg className="timer-svg" viewBox="0 0 54 54">
                    <circle className="timer-bg" cx="27" cy="27" r="23" />
                    <circle className="timer-arc" cx="27" cy="27" r="23" stroke={timerColor}
                      strokeDasharray={`${2 * Math.PI * 23}`}
                      strokeDashoffset={`${2 * Math.PI * 23 * (1 - timerPercent / 100)}`} />
                  </svg>
                  <span className="timer-number" style={{ color: timerColor }}>{timeLeft}</span>
                </div>
              </div>
              <div className="quiz-progress-bar">
                <div className="quiz-progress-fill" style={{ width: `${(currentQ / questions.length) * 100}%` }} />
              </div>
              <h2 className="quiz-question">{q.question}</h2>
              <div className="quiz-options">
                {q.options.map((opt, i) => {
                  let cls = 'quiz-option';
                  if (showFeedback) {
                    cls += ' disabled';
                    if (i === q.correct) cls += ' correct';
                    else if (i === selected) cls += ' wrong';
                  }
                  return (
                    <button key={i} className={cls} onClick={() => handleAnswer(i)}>
                      <span className="option-letter">{String.fromCharCode(65 + i)}</span>
                      {opt}
                    </button>
                  );
                })}
              </div>
              {showFeedback && (
                <div className={`quiz-feedback ${selected === null ? 'timeout' : answers[answers.length - 1]?.correct ? 'correct' : 'wrong'}`}>
                  {selected === null
                    ? <>Temps ecoule ! Bonne reponse : <strong>{q.options[q.correct]}</strong></>
                    : answers[answers.length - 1]?.correct
                    ? <>{q.explication}</>
                    : <>Bonne reponse : <strong>{q.options[q.correct]}</strong>. {q.explication}</>}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── RÉSULTATS ── */}
        {phase === 'finished' && (
          <div className="quiz-results">
            <div className="results-score-circle"
              style={{ background: `conic-gradient(#A98667 ${(score / questions.length) * 360}deg, rgba(169,134,103,0.12) 0deg)` }}>
              <div className="results-score-inner">
                <span className="results-score-number">{score}</span>
                <span className="results-score-total">/{questions.length}</span>
              </div>
            </div>
            <h2 className="results-title">
              {score === questions.length ? 'Parfait !' : score >= questions.length * 0.8 ? 'Excellent !' : score >= questions.length * 0.6 ? 'Bien joue !' : 'Continuez !'}
            </h2>
            <p className="results-subtitle">
              {score >= questions.length * 0.8 ? 'Tres bonne maitrise biblique. Continuez a approfondir.' :
               score >= questions.length * 0.6 ? 'Bonne base. Les moments d\'etude vous aideront a progresser.' :
               'La Parole s\'apprend jour apres jour. Ne vous decouragez pas !'}
            </p>
            <div className="results-stats">
              <div className="results-stat">
                <div className="results-stat-number" style={{ color: '#27ae60' }}>{score}</div>
                <div className="results-stat-label">Correctes</div>
              </div>
              <div className="results-stat">
                <div className="results-stat-number" style={{ color: '#e74c3c' }}>{questions.length - score}</div>
                <div className="results-stat-label">Incorrectes</div>
              </div>
              <div className="results-stat">
                <div className="results-stat-number">{Math.round((score / questions.length) * 100)}%</div>
                <div className="results-stat-label">Score</div>
              </div>
            </div>
            <div className="results-answers">
              {questions.map((q, i) => {
                const ans = answers[i];
                return (
                  <div className="results-answer" key={q.id}>
                    <span>{ans?.correct ? '✓' : '✗'}</span>
                    <div>
                      <p className="answer-q">{q.question}</p>
                      {!ans?.correct && <p className="answer-correct">Reponse : {q.options[q.correct]}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="results-btns">
              <button className="quiz-start-btn" onClick={() => { setPhase('selection'); setAnswers([]); }}>
                Nouveau quiz
              </button>
              <button className="quiz-start-btn btn-ghost" onClick={startQuiz}>
                Rejouer meme selection
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Quiz;